module.exports = __webpack_public_path__ + "54e89eb99d5d2bc8e1da699f880f8bd1.png";